import { DateInput } from "components/DesignSystem/DateInput/DateInput";
import { YYYY_MM_DD } from "constants/date";
import dayjs from "dayjs";
import { Field, FieldProps, Form, Formik } from "formik";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { useToast } from "hooks/useToast";
import {
  useUpdateTaskAssigneeAdminMutation,
  useUpdateTaskAssigneeProviderMutation,
} from "store/apis/serviceTeam";
import { BackendError } from "types/utils/error";

export const TaskPickupDate = ({
  hasAssignedTeam,
  taskId,
  pickupDate,
}: {
  hasAssignedTeam: boolean;
  taskId?: string | null;
  pickupDate?: string | null;
}) => {
  const date = pickupDate ? new Date(pickupDate) : null;
  const [updateTaskAssigneeForAdmin] = useUpdateTaskAssigneeAdminMutation();
  const [updateTaskAssigneeForProvider] =
    useUpdateTaskAssigneeProviderMutation();
  const { alertToast, successToast } = useToast();
  const { isAdmin } = useRoleBasedView();

  let updateTaskAssignee = isAdmin
    ? updateTaskAssigneeForAdmin
    : updateTaskAssigneeForProvider;

  const updateETD = async (date: Date) => {
    try {
      const pickupDate = dayjs(date).format(YYYY_MM_DD);
      if (taskId) {
        await updateTaskAssignee({
          pickup_date: pickupDate,
          taskId: taskId,
        }).unwrap();
        successToast({ message: "Pickup date added successfully" });
      }
    } catch (error) {
      alertToast({
        message: (error as BackendError)?.data?.error?.message,
      });
    }
  };

  const oneYearAgo = dayjs().subtract(1, "year").toDate();

  return (
    <Formik onSubmit={() => {}} initialValues={{ pickup_date: date }}>
      {({ setFieldValue }) => (
        <Form className="t-w-full t-m-0" onClick={(e) => e.stopPropagation()}>
          <Field name="pickup_date">
            {({ field }: FieldProps) => {
              return (
                <DateInput
                  disabled={!hasAssignedTeam}
                  {...field}
                  portalId={"pickup_date_portal_" + taskId}
                  minDate={oneYearAgo}
                  onDateChange={(date) => {
                    setFieldValue("pickup_date", date);
                    updateETD(date);
                  }}
                />
              );
            }}
          </Field>
        </Form>
      )}
    </Formik>
  );
};
